import { render, staticRenderFns } from "./dbm-to-W.vue?vue&type=template&id=e5ba8682&"
import script from "./dbm-to-W.vue?vue&type=script&lang=js&"
export * from "./dbm-to-W.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports